import { ReactNode } from 'react';
import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import { BondProduct } from 'global/Securities/types/api/bond';
import Image from 'global/Image';
import { FALLBACK_AVATAR_SRC, STABLE_EARN_ICON_SRC } from '../../constants';

interface Props {
  product: BondProduct;
  cta?: ReactNode;
  isStableEarn?: boolean;
}

export default function BondProductDisplay({
  product,
  cta,
  isStableEarn,
}: Props) {
  const iconSrc = isStableEarn
    ? STABLE_EARN_ICON_SRC
    : product?.icon_url || FALLBACK_AVATAR_SRC;

  return (
    <Flex justify="space-between" align="center">
      <Flex align="center" style={{ gap: 12 }}>
        <Image
          src={iconSrc}
          style={{ width: '40px', height: '40px', background: 'white' }}
        />
        <Flex direction="column" style={{ gap: 2 }} justify="center">
          <Text family="bold" size="14px">
            {isStableEarn ? 'Stable Earn' : product?.id}
          </Text>
          <Text color="#969696" size="12px">
            {product?.name}
          </Text>
        </Flex>
      </Flex>
      {cta}
    </Flex>
  );
}
